module.exports = __webpack_public_path__ + "static/media/arrow-right-hover.a69228f5.svg";